const config = {
  production: {
    baseUrl: 'https://api.forwardme.com/v1/',
    customerWebsiteUrl: 'https://my.forwardme.com/',
  },
  staging: {
    baseUrl: 'https://api-staging.forwardme.com/v1/',
    customerWebsiteUrl: 'https://staging--forwardme-app.netlify.app/',
  },
  development: {
    baseUrl: 'http://127.0.0.1/v1/',
    customerWebsiteUrl: 'http://localhost:3002/',
  },
}[process.env.REACT_APP_STAGE || 'development']

export default config
